// The public My Trading Journey page (/my-trading-journey): what the three parts answer, a
// demo button for each that opens the sample trader on that part, and the articles that go
// deeper. The blog's Journey articles link here. Words in JourneyLandingData.js.
import { Link } from 'react-router-dom';
import { PublicShell, localPath, usePageLanguage, useTitle } from './PublicPage';
import { DemoButton } from './Landing';
import { useI18n } from './i18n';
import { livePosts } from './blog/posts';
import { JOURNEY_FAQ, JOURNEY_HERO, JOURNEY_PARTS_TEXT, JOURNEY_WHY } from './JourneyLandingData';

const SERIES_OF = { profitable: 'journey-profitable', better: 'journey-better', edge: 'journey-edge' };

export default function JourneyLanding({ user, forceLang, onStartDemo }) {
  const lang = usePageLanguage(forceLang, '/my-trading-journey');
  const { t } = useI18n();
  useTitle(t('My Trading Journey: Is Trading Actually Paying Off? | Market Matrix'));
  const member = user && !user.isDemo;
  const inDemo = Boolean(user && user.isDemo);
  const posts = livePosts();
  const demo = (part) => (member
    ? <Link to={part.to} className="firm-secondary">{t('Open it in your journal')} &rarr;</Link>
    : onStartDemo && <DemoButton inDemo={inDemo} onStart={onStartDemo} to={part.to} label={part.demo} link track={`journey-${part.id}-demo`} />);

  return (
    <PublicShell user={user} className="firm-page journey-landing">
      <header className="page-title firm-hero">
        <p className="eyebrow">{t(JOURNEY_HERO.eyebrow)}</p>
        <h1>{t(JOURNEY_HERO.title)}</h1>
        <p className="subtitle">{t(JOURNEY_HERO.sub)}</p>
        <div className="firm-cta">
          <Link to={member ? '/app/journey/profitable' : '/signup'} className="cta-button">{member ? t('Open My Trading Journey') : t('Start your free journal')} &rarr;</Link>
          {!member && onStartDemo && <DemoButton inDemo={inDemo} onStart={onStartDemo} to="/app/journey/profitable" label="Try it with sample data" track="journey-hero-demo" />}
        </div>
        <p className="cta-note">{t('14 days of every feature free. No credit card.')}</p>
      </header>

      <section className="firm-section">
        <div className="jl-why">
          {JOURNEY_WHY.map(([title, text]) => (
            <div key={title} className="jl-why-card"><strong>{t(title)}</strong><p>{t(text)}</p></div>
          ))}
        </div>
      </section>

      {JOURNEY_PARTS_TEXT.map((part, i) => {
        const reads = posts.filter((p) => p.series === SERIES_OF[part.id]).sort((a, b) => a.seriesPart - b.seriesPart).slice(0, 5);
        return (
          <section key={part.id} id={part.id} className="firm-section jl-part">
            <p className="eyebrow">{t('Part {n} of 3', { n: i + 1 })}</p>
            <h2>{t(part.title)}</h2>
            <p className="jl-lead">{t(part.lead)}</p>
            <ul className="firm-watch">{part.points.map((x) => <li key={x}>{t(x)}</li>)}</ul>
            <p className="jl-demo">{demo(part)}</p>
            {reads.length > 0 && (
              <div className="jl-reads">
                <h3>{t('Read more')}</h3>
                <ul>{reads.map((p) => <li key={p.slug}><Link to={localPath(lang, `/blog/${p.slug}`)}>{(p[lang] || p.en).title}</Link></li>)}</ul>
              </div>
            )}
          </section>
        );
      })}

      <section className="firm-section">
        <h2>{t('Questions')}</h2>
        {JOURNEY_FAQ.map(([q, a]) => (
          <div key={q} className="jl-faq"><h3>{t(q)}</h3><p>{t(a)}</p></div>
        ))}
      </section>

      <section className="final-cta blog-final-cta">
        <h2>{t('Find out where you really stand')}</h2>
        <Link to={member ? '/app/journey/profitable' : '/signup'} className="cta-button">{member ? t('Open My Trading Journey') : t('Start your free journal')} &rarr;</Link>
        <p className="firm-note">{t('Market Matrix is a journaling and analysis tool, not financial advice. Trading futures involves substantial risk of loss.')}</p>
      </section>
    </PublicShell>
  );
}
